/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Case manager details for find-or-create (use case_manager_id instead when selecting existing)
 * @export
 * @interface UpdatePalReauthSubmissionRequestCaseManager
 */
export interface UpdatePalReauthSubmissionRequestCaseManager {
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequestCaseManager
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequestCaseManager
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequestCaseManager
     */
    fax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthSubmissionRequestCaseManager
     */
    email?: string | null;
}

/**
 * Check if a given object implements the UpdatePalReauthSubmissionRequestCaseManager interface.
 */
export function instanceOfUpdatePalReauthSubmissionRequestCaseManager(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatePalReauthSubmissionRequestCaseManagerFromJSON(json: any): UpdatePalReauthSubmissionRequestCaseManager {
    return UpdatePalReauthSubmissionRequestCaseManagerFromJSONTyped(json, false);
}

export function UpdatePalReauthSubmissionRequestCaseManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthSubmissionRequestCaseManager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function UpdatePalReauthSubmissionRequestCaseManagerToJSON(value?: UpdatePalReauthSubmissionRequestCaseManager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'phone': value.phone,
        'fax': value.fax,
        'email': value.email,
    };
}

